module.exports = __webpack_public_path__ + "statics/img/earthwork-2.e24e376f.png";